import React, { useEffect, useState } from "react";
import CardLayoutOne from "../../components/cards/CardLayoutOne";
import { t } from "i18next";
import MainButton from "../../components/buttons/MainButton";
import PlanProductOne from "./components/PlanProductOne";
import { useNavigate } from "react-router-dom";
import { codeStatusRequest } from "../../core/subscription/request";
import Snackbar, { SnackbarType } from "../../components/snackbar/Snackbar";

const Premium = () => {
  const navigate = useNavigate();
  const products = [
    {
      id: 1,
      items: [
        {
          id: 4,
          name: `${t("treenft.head")} 1x`,
          description: `${t("treenft.description")}`,
          price: "55",
          image:
            "https://gardenof.life/storage/images/brazil/TsRCFyiBHciN6L8wtqKYWoEcm.png",
          link: "/subscription/purchase",
          is_subscribed: true,
          quantity: 1,
        },
        {
          id: 8,
          name: `${t("endarged.head")}`,
          description: `${t("endarged.description")}`,
          price: "33",
          image:
            "https://gardenof.life/storage/images/botswana/na48cTEFroTcLryo3wiBmicVC.png",
          link: "/subscription/purchase",
          is_subscribed: true,
          quantity: 1,
        },
      ],
    },
    {
      id: 2,
      items: [
        {
          id: 25,
          name: `${t("compassion.head")} 1x`,
          description: `${t("compassion.description")}`,
          price: "55",
          image:
            "https://gardenof.life/assets/images/compassion-card/compassion-card.png",
          link: "/subscription/purchase",
          is_subscribed: true,
          quantity: 1,
        },
        {
          id: 8,
          name: `${t("endarged.head")}`,
          description: `${t("endarged.description")}`,
          price: "33",
          image:
            "https://gardenof.life/storage/images/botswana/na48cTEFroTcLryo3wiBmicVC.png",
          link: "/subscription/purchase",
          is_subscribed: true,
          quantity: 1,
        },
      ],
    },

    {
      id: 3,
      items: [
        {
          id: 10,
          name: `${t("crystal.head")} 1x`,
          description: `${t("crystal.description")}`,
          price: "88",
          image:
            "https://gardenof.life/storage/images/iceland/BwNSlG7JpbwwDcOd303raUGNT.png",
          link: "/subscription/purchase",
          is_subscribed: true,
          quantity: 1,
        },
      ],
    },
  ];
  const [selectedCardId, setSelectedCardId] = useState<number | null>(() => {
    return localStorage.getItem("selectedCardId")
      ? Number(localStorage.getItem("selectedCardId"))
      : null;
  });

  useEffect(() => {
    localStorage.setItem("selectedCardId", selectedCardId?.toString() || "");
  }, [selectedCardId]);

  const handleSelect = (id: number) => {
    setSelectedCardId(selectedCardId === id ? null : id);
  };

  const handleClick = () => {
    if (selectedCardId) {
      const selectedProduct = products.find(
        (product) => product.id === selectedCardId
      );
      const subscriptionLinkCode =
        new URL(window.location.href).searchParams.get("code") || "defaultCode";
      localStorage.setItem("selectedProduct", JSON.stringify(selectedProduct));
      localStorage.setItem("subscriptionLinkCode", subscriptionLinkCode);
      navigate("/checkout");
    }
  };

  const [snackbarState, setSnackbarState] = useState<{
    show: boolean;
    message: string;
    type: SnackbarType;
  }>({
    show: false,
    message: "",
    type: "error", // Default type
  });

  const [isBuyButtonDisabled, setIsBuyButtonDisabled] = useState(false);

  // Function to show the snackbar
  const showSnackbar = (message: string, type: SnackbarType) => {
    setSnackbarState({ show: true, message, type });
  };

  // Function to hide the snackbar
  const hideSnackbar = () => {
    setSnackbarState((prevState) => ({ ...prevState, show: false }));
  };

  const codeStatus = async () => {
    const subscriptionLinkCode =
      new URL(window.location.href).searchParams.get("code") || "defaultCode";

    try {
      const paymentData = {
        // subscription: true,
        subscription_link_code: subscriptionLinkCode,
      };

      const response = await codeStatusRequest(paymentData);
      if (response.data.status == "error") {
        setIsBuyButtonDisabled(true);
        showSnackbar(
          "This product purchase link against Subscription is already Consumed",
          "error"
        );
      } else {
        setIsBuyButtonDisabled(false);
      }
    } catch (error) {
      console.error("Wrong Code:", error);
    }
  };
  useEffect(() => {
    codeStatus();
  }, []);

  window.addEventListener("unload", (event) => {
    codeStatus();
    console.log("API call after page reload");
  });

  return (
    <>
      <section className="pb-5 subscription-sec">
        <div className="container">
          <div className="subscription-head-sec text-center">
            <h1 className="mb-3">{t("premium.heading")} {t("plan")}</h1>
            <h6 className="mb-3">{t("product.subhead")}</h6>
          </div>
          <div className="row mt-5">
            {products.map((product) => (
              <div
                key={product.id}
                className={`col-md-${
                  product.items.length === 1 ? "4" : "6"
                } mb-4`}
              >
                <div className="card-layout three pb-4">
                  <div className="row 2-column">
                    {product.items.map((item) => (
                      <PlanProductOne
                        key={item.id}
                        btnText={t("buttons.buyNow")}
                        btnFullWidth={""}
                        colClass={`
                        col-lg-${product.items.length === 1 ? "12" : "6"} 
                        col-md-${product.items.length === 1 ? "12" : "6"}
                      `}
                        shadow={true}
                        title={item.name}
                        bgColor={"bg-transparent"}
                        image={item.image}
                        titleClass={"f-title-bold"}
                        imageClass={"h-200"}
                        price={item.price}
                        description={item.description}
                      />
                    ))}
                  </div>
                  <div className="text-center">
                    <button
                      className="btn btn-primary-dark checkbox-btn"
                      onClick={() => handleSelect(product.id)}
                      disabled={
                        selectedCardId !== null && selectedCardId !== product.id
                      }
                    >
                      <input
                        type="checkbox"
                        id={`select${product.id}`}
                        className="custom-checkbox"
                        onChange={() => handleSelect(product.id)}
                        checked={selectedCardId === product.id}
                      />
                      <span>Select</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <MainButton
              onClick={handleClick}
              className={`btn btn-primary-dark ps-lg-5 pe-lg-5 ps-3 pe-3`}
              text="Buy Now"
              withLogo={false}
              disabled={!selectedCardId || isBuyButtonDisabled == true}
            />
          </div>
        </div>
      </section>
      <Snackbar
        message={snackbarState.message}
        type={snackbarState.type}
        show={snackbarState.show}
        onClose={hideSnackbar}
        duration={9000}
      />
    </>
  );
};

export default Premium;

// in this code if i selected a product and i click the buy now button its redirect to checkout page i need to show which product i selected  product name product quantity and price image
